enum RvqPreferenceType {
    Practitioner,
    Medication,
    Location
}

export { RvqPreferenceType };
